// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetHandoverEntity from './entities/asset-handover.json';
import assetHandoverMenu from '../pages/asset-handover/menu.json';
import assetHandoverFullForm from '../pages/asset-handover/forms/full.json';
import assetHandoverContextForm from '../pages/asset-handover/forms/context.json';
import assetHandoverMiniForm from '../pages/asset-handover/forms/mini.json';
import assetHandoverLookupForm from '../pages/asset-handover/forms/lookup.json';
import assetHandoverTableView from '../pages/asset-handover/views/table.json';
import assetHandoverCardsView from '../pages/asset-handover/views/cards.json';
import assetHandoverCalendarView from '../pages/asset-handover/views/calendar.json';
import assetHandoverDashboardView from '../pages/asset-handover/views/dashboard.json';

/** Тип запису «Передання майна» зі сторінками пакета: меню, форми та подання з pages/asset-handover/. */
export const assetHandoverDefinition: IRecordTypeDefinition = {
  ...assetHandoverEntity,
  views: assembleViewSet({
      table: assetHandoverTableView,
      cards: assetHandoverCardsView,
      calendar: assetHandoverCalendarView,
      dashboard: assetHandoverDashboardView,
  }),
  form: assetHandoverFullForm,
  forms: { full: assetHandoverFullForm, context: assetHandoverContextForm, mini: assetHandoverMiniForm, lookup: assetHandoverLookupForm },
  menu: assetHandoverMenu,
} as IRecordTypeDefinition;
